var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0301 11.5698L7.38173 1.71152C7.26997 1.51646 7.11864 1.45833 7 1.45833C6.88136 1.45833 6.73003 1.51646 6.61826 1.71153L0.969894 11.5698C0.843454 11.7905 0.84921 12.0494 0.952422 12.2559C1.05472 12.4605 1.2084 12.5417 1.35163 12.5417L12.6484 12.5417C12.7916 12.5417 12.9453 12.4605 13.0476 12.2559C13.1508 12.0494 13.1565 11.7905 13.0301 11.5698ZM13.7893 11.1348L8.14094 1.27653C7.61138 0.352267 6.38861 0.352271 5.85905 1.27653L0.210682 11.1348C-0.35683 12.1253 0.288863 13.4167 1.35163 13.4167L12.6484 13.4167C13.7111 13.4167 14.3568 12.1253 13.7893 11.1348ZM6.12727 4.95833L6.49669 8.89583C6.51555 9.10659 6.73527 9.33333 7 9.33333C7.26473 9.33333 7.48445 9.10659 7.50331 8.89583L7.87273 4.95833C7.90891 4.55409 7.50777 4.08333 7 4.08333C6.49223 4.08333 6.09109 4.55409 6.12727 4.95833ZM7 11.6667C7.48325 11.6667 7.875 11.2749 7.875 10.7917C7.875 10.3084 7.48325 9.91667 7 9.91667C6.51675 9.91667 6.125 10.3084 6.125 10.7917C6.125 11.2749 6.51675 11.6667 7 11.6667Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrors);
export default __webpack_public_path__ + "static/media/iconErrors.ea4a35aa8e18e2c4566091ca3f00a6f0.svg";
export { ForwardRef as ReactComponent };